module.exports = __webpack_public_path__ + "img/05—Applications—VPN server > Inline Edit.88bd0b79.jpg";